module.exports = __webpack_public_path__ + "img/Picture31.7565b44f.png";